/**
 * @generated SignedSource<<a97fa0e0b34d8cc0f7fd6c9770d164a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FormMetadataStyleEnum = "ImageCenter" | "ImageLeft" | "NoImage";
export type FormMetadataTemplateEnum = "Basic" | "CompanyLong" | "CompanyShort" | "PasswordProtected" | "PasswordProtectedShort";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type StatusUiPermissionEnum = "OTP" | "PUBLIC" | "RESTRICTED" | "TOKEN";
export type VertexSearchAgentConnectionWhereArgs = {
  vertex?: VertexSearchAgentInputType | null | undefined;
};
export type VertexSearchAgentInputType = {
  categoryIn?: ReadonlyArray<string | null | undefined> | null | undefined;
  hubId?: string | null | undefined;
  hubPageId?: string | null | undefined;
  pageType?: string | null | undefined;
  query?: string | null | undefined;
  statusIn?: ReadonlyArray<PostStatusEnum | null | undefined> | null | undefined;
  znglistId?: string | null | undefined;
};
export type GCP_VertexSearch_Single_Query$variables = {
  where?: VertexSearchAgentConnectionWhereArgs | null | undefined;
};
export type GCP_VertexSearch_Single_Query$data = {
  readonly vertexSearchAgent: {
    readonly correctedQuery: string | null | undefined;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly author: {
          readonly node: {
            readonly id: string;
            readonly name: string | null | undefined;
            readonly slug: string | null | undefined;
            readonly username: string | null | undefined;
          };
        } | null | undefined;
        readonly databaseId: number;
        readonly id: string;
        readonly link: string | null | undefined;
        readonly searchResults: {
          readonly extractiveAnswers: ReadonlyArray<{
            readonly content: string | null | undefined;
            readonly pageNumber: string | null | undefined;
          } | null | undefined> | null | undefined;
          readonly snippets: ReadonlyArray<{
            readonly snippet: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status: string | null | undefined;
        readonly statusSettings: {
          readonly approved: {
            readonly id: string | null | undefined;
            readonly timestamp: string | null | undefined;
            readonly user: {
              readonly name: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly stateWhenApproved: {
            readonly status: PostStatusEnum | null | undefined;
            readonly uiPermission: {
              readonly token: string | null | undefined;
              readonly type: StatusUiPermissionEnum | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly status: PostStatusEnum | null | undefined;
          readonly uiPermission: {
            readonly token: string | null | undefined;
            readonly type: StatusUiPermissionEnum | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly title: string | null | undefined;
        readonly znglyContent: {
          readonly aiSummary: string | null | undefined;
          readonly contentEmbedHtml: string | null | undefined;
          readonly contentFile: {
            readonly description: string | null | undefined;
            readonly id: string;
            readonly mediaDetails: {
              readonly sizes: ReadonlyArray<{
                readonly name: string | null | undefined;
                readonly sourceUrl: string | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly mediaItemUrl: string | null | undefined;
            readonly mimeType: string | null | undefined;
          } | null | undefined;
          readonly contentLink: string | null | undefined;
          readonly contentMediaName: string | null | undefined;
          readonly contentMediaType: string | null | undefined;
          readonly ctaLink: string | null | undefined;
          readonly ctaName: string | null | undefined;
          readonly featuredImageFile: {
            readonly description: string | null | undefined;
            readonly id: string;
            readonly mediaDetails: {
              readonly sizes: ReadonlyArray<{
                readonly name: string | null | undefined;
                readonly sourceUrl: string | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly mediaItemUrl: string | null | undefined;
            readonly mimeType: string | null | undefined;
          } | null | undefined;
          readonly featuredImageLink: string | null | undefined;
          readonly form: {
            readonly node: {
              readonly content: string | null | undefined;
              readonly id: string;
              readonly imageUrl: string | null | undefined;
              readonly marketingConsent: boolean | null | undefined;
              readonly metadata: {
                readonly cookieExpiration: string | null | undefined;
                readonly formStyle: FormMetadataStyleEnum | null | undefined;
                readonly formTemplate: FormMetadataTemplateEnum | null | undefined;
                readonly submitSuccessText: string | null | undefined;
              } | null | undefined;
              readonly password: boolean | null | undefined;
              readonly schema: string | null | undefined;
              readonly title: string;
              readonly uiSchema: string | null | undefined;
            };
          } | null | undefined;
          readonly htmlDesc: string | null | undefined;
          readonly shortText: string | null | undefined;
        } | null | undefined;
      };
    }>;
    readonly summary: {
      readonly summaryText: string | null | undefined;
      readonly summaryWithMetadata: {
        readonly citationMetadata: {
          readonly citations: ReadonlyArray<{
            readonly endIndex: number | null | undefined;
            readonly sources: ReadonlyArray<{
              readonly referenceIndex: string | null | undefined;
            } | null | undefined> | null | undefined;
            readonly startIndex: number | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly references: ReadonlyArray<{
          readonly document: string | null | undefined;
          readonly title: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly summary: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type GCP_VertexSearch_Single_Query = {
  response: GCP_VertexSearch_Single_Query$data;
  variables: GCP_VertexSearch_Single_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "correctedQuery",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Summary",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summaryText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SummaryWithMetadata",
      "kind": "LinkedField",
      "name": "summaryWithMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CitationMetadata",
          "kind": "LinkedField",
          "name": "citationMetadata",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Citation",
              "kind": "LinkedField",
              "name": "citations",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startIndex",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endIndex",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CitationSource",
                  "kind": "LinkedField",
                  "name": "sources",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "referenceIndex",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SummaryReference",
          "kind": "LinkedField",
          "name": "references",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "document",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "NodeWithAuthorToUserConnectionEdge",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "UIPermission",
  "kind": "LinkedField",
  "name": "uiPermission",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "StateWhenApproved",
  "kind": "LinkedField",
  "name": "stateWhenApproved",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "AiSearchResults",
  "kind": "LinkedField",
  "name": "searchResults",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Snippet",
      "kind": "LinkedField",
      "name": "snippets",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "snippet",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ExtractiveAnswer",
      "kind": "LinkedField",
      "name": "extractiveAnswers",
      "plural": true,
      "selections": [
        (v14/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageNumber",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mediaItemUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mimeType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MediaDetails",
    "kind": "LinkedField",
    "name": "mediaDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MediaSize",
        "kind": "LinkedField",
        "name": "sizes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceUrl",
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "ZnglyVideo_Znglycontent",
  "kind": "LinkedField",
  "name": "znglyContent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "aiSummary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ctaName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentMediaType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentEmbedHtml",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentMediaName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaItem",
      "kind": "LinkedField",
      "name": "contentFile",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "featuredImageLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaItem",
      "kind": "LinkedField",
      "name": "featuredImageFile",
      "plural": false,
      "selections": (v16/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "htmlDesc",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ZnglyVideo_ZnglycontentToFormConnectionEdge",
      "kind": "LinkedField",
      "name": "form",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Form",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v3/*: any*/),
            (v14/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "schema",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uiSchema",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FormMetadata",
              "kind": "LinkedField",
              "name": "metadata",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "formStyle",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "formTemplate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cookieExpiration",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "submitSuccessText",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "marketingConsent",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "password",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GCP_VertexSearch_Single_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VertexSearchAgentConnection",
        "kind": "LinkedField",
        "name": "vertexSearchAgent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VertexSearchAgentConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyVideo",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v3/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusSettings",
                    "kind": "LinkedField",
                    "name": "statusSettings",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ApprovedState",
                        "kind": "LinkedField",
                        "name": "approved",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GCP_VertexSearch_Single_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VertexSearchAgentConnection",
        "kind": "LinkedField",
        "name": "vertexSearchAgent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VertexSearchAgentConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZnglyVideo",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v3/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StatusSettings",
                    "kind": "LinkedField",
                    "name": "statusSettings",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ApprovedState",
                        "kind": "LinkedField",
                        "name": "approved",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "21ec30ee58ab0a8507c9ec3f1a6758fa",
    "id": null,
    "metadata": {},
    "name": "GCP_VertexSearch_Single_Query",
    "operationKind": "query",
    "text": "query GCP_VertexSearch_Single_Query(\n  $where: VertexSearchAgentConnectionWhereArgs = null\n) {\n  vertexSearchAgent(first: 100, where: $where) {\n    correctedQuery\n    summary {\n      summaryText\n      summaryWithMetadata {\n        summary\n        citationMetadata {\n          citations {\n            startIndex\n            endIndex\n            sources {\n              referenceIndex\n            }\n          }\n        }\n        references {\n          title\n          document\n        }\n      }\n    }\n    edges {\n      node {\n        id\n        author {\n          node {\n            id\n            name\n            username\n            slug\n          }\n        }\n        databaseId\n        title\n        link\n        status\n        statusSettings {\n          status\n          uiPermission {\n            type\n            token\n          }\n          stateWhenApproved {\n            status\n            uiPermission {\n              type\n              token\n            }\n          }\n          approved {\n            id\n            timestamp\n            user {\n              name\n              id\n            }\n          }\n        }\n        searchResults {\n          snippets {\n            snippet\n          }\n          extractiveAnswers {\n            content\n            pageNumber\n          }\n        }\n        znglyContent {\n          aiSummary\n          ctaLink\n          ctaName\n          contentMediaType\n          contentLink\n          contentEmbedHtml\n          contentMediaName\n          contentFile {\n            id\n            mediaItemUrl\n            mimeType\n            mediaDetails {\n              sizes {\n                sourceUrl\n                name\n              }\n            }\n            description\n          }\n          featuredImageLink\n          featuredImageFile {\n            id\n            mediaItemUrl\n            mimeType\n            mediaDetails {\n              sizes {\n                sourceUrl\n                name\n              }\n            }\n            description\n          }\n          shortText\n          htmlDesc\n          form {\n            node {\n              id\n              title\n              content\n              schema\n              uiSchema\n              metadata {\n                formStyle\n                formTemplate\n                cookieExpiration\n                submitSuccessText\n              }\n              marketingConsent\n              password\n              imageUrl\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fdd100142f6bcbcc743b4631a7ed6213";

export default node;
